/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1SsoimageIdMutationRequest,
  PutApiV1SsoimageIdMutationResponse,
  PutApiV1SsoimageIdPathParams,
  PutApiV1SsoimageId400,
  PutApiV1SsoimageId401,
  PutApiV1SsoimageId500,
} from "../../types/SSOImageController/PutApiV1SsoimageId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1SsoimageId } from "../../clients/SSOImageController/putApiV1SsoimageId.ts";

export const putApiV1SsoimageIdMutationKey = () =>
  [{ url: "/api/v1/ssoimage/:id" }] as const;

export type PutApiV1SsoimageIdMutationKey = ReturnType<
  typeof putApiV1SsoimageIdMutationKey
>;

export function putApiV1SsoimageIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutApiV1SsoimageIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putApiV1SsoimageIdMutationKey();
  return mutationOptions<
    PutApiV1SsoimageIdMutationResponse,
    ResponseErrorConfig<
      PutApiV1SsoimageId400 | PutApiV1SsoimageId401 | PutApiV1SsoimageId500
    >,
    {
      id: PutApiV1SsoimageIdPathParams["id"];
      data: PutApiV1SsoimageIdMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1SsoimageId(id, data, config);
    },
  });
}

/**
 * @description Atualiza os dados de uma SSOImage, incluindo título, categoria, datas e idiomas. Para cada idioma informado, o arquivo .json é enviado ao Azure Blob Storage e o URL de armazenamento é atualizado. Idiomas com Id informado são atualizados; idiomas sem Id são criados como novos registros. **(Requer Authorization para autenticação)**
 * @summary Atualizar imagem SSO (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage/:id}
 */
export function usePutApiV1SsoimageId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1SsoimageIdMutationResponse,
      ResponseErrorConfig<
        PutApiV1SsoimageId400 | PutApiV1SsoimageId401 | PutApiV1SsoimageId500
      >,
      {
        id: PutApiV1SsoimageIdPathParams["id"];
        data: PutApiV1SsoimageIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PutApiV1SsoimageIdMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1SsoimageIdMutationKey();

  const baseOptions = putApiV1SsoimageIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1SsoimageIdMutationResponse,
    ResponseErrorConfig<
      PutApiV1SsoimageId400 | PutApiV1SsoimageId401 | PutApiV1SsoimageId500
    >,
    {
      id: PutApiV1SsoimageIdPathParams["id"];
      data: PutApiV1SsoimageIdMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1SsoimageIdMutationResponse,
    ResponseErrorConfig<
      PutApiV1SsoimageId400 | PutApiV1SsoimageId401 | PutApiV1SsoimageId500
    >,
    {
      id: PutApiV1SsoimageIdPathParams["id"];
      data: PutApiV1SsoimageIdMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1SsoimageIdMutationResponse,
    ResponseErrorConfig<
      PutApiV1SsoimageId400 | PutApiV1SsoimageId401 | PutApiV1SsoimageId500
    >,
    {
      id: PutApiV1SsoimageIdPathParams["id"];
      data: PutApiV1SsoimageIdMutationRequest;
    },
    TContext
  >;
}
